"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsurancePeriod = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const yup_1 = require("@hookform/resolvers/yup");
const common_1 = require("@pulse-smart-components-kit/common");
const header_with_sub_text_1 = require("@pulse-web-ui/header-with-sub-text");
const date_fns_1 = require("date-fns");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const components_1 = require("./components");
const i18n_1 = require("./i18n");
const insurance_period_style_1 = require("./insurance-period.style");
const insurance_period_type_1 = require("./insurance-period.type");
const DAYS_IN_YEAR = 365;
exports.InsurancePeriod = (0, react_1.memo)((0, react_1.forwardRef)(({ value, onChange, options: { coverageItems, startDate, endDate, maxDuration }, formSchema, formContext, onAnalyticEventSend, isSubmitting, fieldState, }, forwardRef) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { control, watch, setValue, formState: { errors, isValid }, trigger, setError, } = (0, react_hook_form_1.useForm)({
        defaultValues: value,
        resolver: (0, yup_1.yupResolver)(formSchema),
        mode: 'all',
        context: formContext,
    });
    (0, react_1.useEffect)(() => {
        if (fieldState?.error?.coverageItems) {
            setError('coverageItems', {
                message: fieldState?.error?.coverageItems?.message || '',
            });
        }
        if (fieldState?.error?.insuranceDates?.start) {
            setError('insuranceDates.start', {
                message: fieldState?.error?.insuranceDates?.start.message || '',
            });
        }
        if (fieldState?.error?.insuranceDates?.end) {
            setError('insuranceDates.end', {
                message: fieldState?.error?.insuranceDates?.end.message || '',
            });
        }
    }, [
        fieldState?.error?.coverageItems,
        fieldState?.error?.insuranceDates?.start,
        fieldState?.error?.insuranceDates?.end,
    ]);
    (0, react_1.useEffect)(() => {
        const subscription = watch((values, { name, type }) => {
            onChange(values);
            const { yearPolicy } = values;
            if (yearPolicy && name === 'insuranceDates' && type === 'change') {
                setValue('yearPolicy', false);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);
    (0, react_1.useEffect)(() => {
        if (isSubmitting) {
            trigger();
        }
    }, [isSubmitting]);
    (0, react_1.useEffect)(() => {
        setValue('isValid', isValid);
    }, [isValid]);
    const maxEndDate = (0, react_1.useMemo)(() => {
        const startValue = value.insuranceDates?.start ??
            (0, common_1.convertDateByTimeZoneStrict)(new Date(startDate));
        return maxDuration
            ? (0, date_fns_1.addDays)(startValue, maxDuration - 1)
            : new Date(endDate);
    }, [maxDuration, endDate, startDate, value.insuranceDates?.start]);
    const handleChangePolicy = (0, react_1.useCallback)((onChange) => (checked) => {
        onChange(checked);
        const { insuranceDates } = value;
        if (checked) {
            const start = insuranceDates?.start ??
                (0, common_1.convertDateByTimeZoneStrict)(new Date(startDate));
            const afterYearDate = (0, date_fns_1.addDays)(start, DAYS_IN_YEAR);
            const end = (0, date_fns_1.isAfter)((0, date_fns_1.startOfDay)(afterYearDate), (0, date_fns_1.startOfDay)(maxEndDate))
                ? maxEndDate
                : afterYearDate;
            setValue('insuranceDates', {
                ...insuranceDates,
                start,
                end,
            }, { shouldValidate: checked });
        }
        if (checked) {
            onAnalyticEventSend?.(insurance_period_type_1.InsurancePeriodAnalyticEvent.ON_DATES_SELECT);
        }
    }, [value, onAnalyticEventSend, maxEndDate, startDate]);
    return ((0, jsx_runtime_1.jsx)(insurance_period_style_1.Form, { ref: forwardRef, children: (0, jsx_runtime_1.jsxs)(insurance_period_style_1.FormWrapper, { children: [(0, jsx_runtime_1.jsx)(header_with_sub_text_1.HeaderWithSubText, { title: t('SMART:InsurancePeriod.title', {
                        defaultValue: i18n_1.i18nDefaultValues.InsurancePeriod.title,
                    }), subTitle: (0, jsx_runtime_1.jsx)(insurance_period_style_1.StyledSubTitle, { children: t('SMART:InsurancePeriod.subtitle', {
                            defaultValue: i18n_1.i18nDefaultValues.InsurancePeriod.subtitle,
                        }) }) }), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { render: ({ field, fieldState: { error } }) => ((0, jsx_runtime_1.jsx)(components_1.CoverageItems, { value: field.value, onChange: field.onChange, error: error, items: coverageItems, onAnalyticEventSend: onAnalyticEventSend })), control: control, name: "coverageItems" }), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { render: ({ field }) => ((0, jsx_runtime_1.jsx)(components_1.Policy, { value: Boolean(field.value), onChange: handleChangePolicy(field.onChange) })), control: control, name: "yearPolicy" }), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { render: ({ field }) => ((0, jsx_runtime_1.jsx)(components_1.Calendar, { value: field.value, onChange: field.onChange, error: errors.insuranceDates, yearPolicy: Boolean(value?.yearPolicy), startDate: startDate, endDate: endDate, maxEndDate: maxEndDate, onAnalyticEventSend: onAnalyticEventSend })), control: control, name: "insuranceDates" })] }) }));
}));
